import { combineReducers } from "redux";
import docksMapReducer from "./docks_map_reducer";

export default docksMapReducer;
